<template>
  <div class="overlay" @click="cancelClick">
    <div class="overlay_inner channel_list" @click.stop>
      <app-button-delete @click="cancelClick" class="btn_close"/>
      <p class="note">
        {{ translations.pairingDetails }}
      </p>
      <table class="pairing_broadcast">
        <tbody>
          <tr v-for="row in Object.keys(item)">
            <th>{{ row }}</th>
            <td v-if="typeof item[row] !== 'object' || item[row] === null">{{ item[row] }}</td>
            <td v-else-if="row !== 'broadcasts'">
              <div v-for="(subRow, key) in Object.keys(item[row])">
                <span v-for="subSubRow in Object.keys(item[row][subRow])">
                  <span v-if="key++ !== 0">, </span>{{ subSubRow }}: {{ item[row][subRow][subSubRow] }}
                </span>
                <br>
              </div>
            </td>
            <td v-else>
              <span v-for="subRow in Object.keys(item[row])">
                <router-link
                    :to="{ name: 'broadcast', params: { id: item[row][subRow]['id'] } }"
                    class="broadcast_id"
                >
                  {{ item[row][subRow]['name'] }}: {{ item[row][subRow]['id'] }}
                </router-link>&nbsp;
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'pairing-detail-dialog',
    props: {
      item: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        formatLabelId: null,
        search: ''
      }
    },
    computed: {
      translations() {
        return {
          pairingDetails: this.$gettext("Informace o párování"),
        }
      }
    },
    methods: {
      cancelClick() {
        this.$emit('refreshDetailItem')
      }
    }
  }
</script>
